import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5ab4480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-right see-more"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_section_header = _resolveComponent("section-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_merchant_card = _resolveComponent("merchant-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_slides = _resolveComponent("slides")!

  return (!$setup.loading && ($setup.sectionProducts.length > 0 ||
                          ($props.products && $props.products.length > 0) || ($props.merchants && $props.merchants.length > 0)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_section_header, {
          icon: $props.icon,
          title: $props.title || $setup.getLocalizedStr($setup.section, 'title', 'titleEn')
        }, null, 8, ["icon", "title"]),
        (!$props.hideSeeMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($props.sectionId)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    size: "small",
                    fill: "clear",
                    "router-link": $props.link || `/sections/${$props.sectionId}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('HomePage.seeMore')), 1)
                    ]),
                    _: 1
                  }, 8, ["router-link"]))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    size: "small",
                    fill: "clear",
                    "router-link": {
        name: $props.link,
        params: { parentPath: '/home' }
      }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('HomePage.seeMore')), 1)
                    ]),
                    _: 1
                  }, 8, ["router-link"]))
            ]))
          : _createCommentVNode("", true),
        ($props.merchants)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.merchants, (merchant) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      "size-xs": "12",
                      "size-md": "6",
                      "size-xl": "4",
                      "size-lg": "3",
                      key: merchant.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_merchant_card, { merchant: merchant }, null, 8, ["merchant"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($props.useRowCol)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($props.products || $setup.sectionProducts), (product) => {
                        return (_openBlock(), _createBlock(_component_ion_col, {
                          "size-xs": "6",
                          "size-md": "4",
                          "size-xl": "3",
                          key: product.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_product_card, {
                              product: product,
                              hideDetails: "true"
                            }, null, 8, ["product"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_slides, {
                    key: 1,
                    products: $props.products || $setup.sectionProducts
                  }, null, 8, ["products"]))
            ])),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}